import { render, staticRenderFns } from "./PriceResult.vue?vue&type=template&id=3fbf5c61&"
import script from "./PriceResult.vue?vue&type=script&lang=js&"
export * from "./PriceResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports